/** biome-ignore-all lint/style/useNamingConvention: GA4 reserved param names */
import { MARKETING_EVENTS } from '@repo/analytics';
import { classifyChannel } from '@repo/config';
import { recordWebVisitorV1Api } from '@repo/sdk';
import { isBotUserAgent } from '../i18n/is-bot-user-agent';
import { readAttributionFromCookie } from './attribution/read-attribution-from-cookie';
import { buildInstallIntentPayload } from './build-install-intent-payload';
import { buildWebFingerprint } from './build-web-fingerprint';
import { getOrCreateVisitorId } from './get-or-create-visitor-id';
import { pageContextFromPathname } from './page-context-from-pathname';
import { trackEvent } from './track-event';

function currentReferrerHost(): string | null {
  try {
    return document.referrer ? new URL(document.referrer).host.slice(0, 200) : null;
  } catch {
    return null;
  }
}

export function recordInstallIntent(store: 'ios' | 'android' | 'web'): void {
  if (typeof window === 'undefined' || isBotUserAgent(navigator.userAgent)) {
    return;
  }
  const cookie = readAttributionFromCookie();
  const page = pageContextFromPathname(window.location.pathname);
  const referrerHost = currentReferrerHost();
  const channel = cookie?.channel ?? classifyChannel({ referrerHost });

  trackEvent(MARKETING_EVENTS.installIntent, {
    store,
    channel,
    page_template: page.template,
    page_phrase: page.phrase ?? '',
  });

  recordWebVisitorV1Api({
    visitorId: getOrCreateVisitorId(),
    fingerprint: buildWebFingerprint(),
    attributionPayload: JSON.stringify(
      buildInstallIntentPayload(cookie, page, channel, referrerHost),
    ),
  }).catch(() => {});
}
